
// import headerList from "@/components/common/header-list.vue";
import { paginationMixin } from "@/mixins/paginationMixin";
import { _ } from "vue-underscore";
export default {
	data: () => ({
		selectedEvaluator:{},
		evaluator:{},
		comments:"",
		evaluations:[],
		tableData:[],
		showLoader: false,
		sortBy:"",
		sortDirection:'asc'

	}),
	mixins: [paginationMixin],
	methods: {
		applySort(sortBy){
			this.tableData = _.sortBy(this.tableData, function(column) { return column[sortBy]; });
			if(this.sortBy == sortBy && this.sortDirection=='asc'){
				this.sortDirection='desc';
				this.tableData = this.tableData.reverse();
			}else{
				this.sortDirection='asc';
			}
			this.sortBy = sortBy;
		},

		searchData(){
			const _vm =this;
			this.tableData = _.filter(this.evaluations,function(element){
				return (element.student_name.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.district_name.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.school_name.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.student_dob.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.compliance_date.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.zip_code.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1);
			})
		},

		resetForm() {
			this.$refs.observer.reset();
			this.evaluator = {
				id: 0,
			};
		},
		submit() {
			let _vm = this;
			let fd = new FormData();
			fd.append("comments",this.comments);
			fd.append("evaluation_id",this.selectedEvaluator.id);
			this.axios
				.post("/set_evaluations_as_revision_needed.php", fd)
				.then(function() {
					_vm.comments="";
					_vm.selectedEvaluator ={};
					_vm.getOpenEvaluations();
				})
				.catch(function(error) {
					console.log(error);
				});
		},
		getOpenEvaluations() {
			let _vm = this;
			_vm.showLoader = true;
			this.axios
				.get("/get_evaluations.php?eval_selection_type=Non-Revised")
				.then(function(response) {
					_vm.showLoader = false;
					response.data.data.forEach(element => {
						element["isSelected"] = false;
					});
					_vm.evaluations = response.data.data;
					_vm.tableData = response.data.data;

				})
				.catch(function(error) {
					console.log(error);
				});
		},

	},
	mounted() {
		this.getOpenEvaluations();
	}
};
